import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  LinearProgress,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Button, DialogTitle } from "common";
import ProgramVariantAvatar from "components/ProgramVariantAvatar/ProgramVariantAvatar";
import useHeaderHeight from "helpers/useHeaderHeight";
import I18n from "i18n";
import moment from "moment";
import UpgradeCard from "./UpgradeCard";
import { useUpgradeContext } from "./UpgradeProvider";
import UpgradesFilter from "./UpgradesFilter";
import UpgradesList from "./UpgradesList";

const UpgradeDialog: React.FC = () => {
  const {
    item,
    save,
    isDirty,
    open,
    loading,
    handleClose,
    selectedProgramVariant,
    booking,
  } = useUpgradeContext();
  const headerHeight = useHeaderHeight();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      fullScreen={isMobile}
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle
        onClose={handleClose}
        titleBoxProps={{
          sx: {
            display: "flex",
            alignItems: "center",
            gap: 1,
          },
        }}
      >
        <ProgramVariantAvatar
          programVariantId={booking?.program_variant_id}
          //sx={{ width: 24, height: 24, fontSize: "0.5rem" }}
        />
        <Box>
          {I18n.t("Booking.upgradeTitle")}
          <Typography variant="subtitle2">
            {booking.name}
            {booking.event?.start_time
              ? `, ${moment(booking.event?.start_time).format("L LT")}`
              : ""}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <UpgradesFilter />
          <UpgradesList />
          {loading && (
            <LinearProgress
              sx={{ position: "fixed", left: 0, top: headerHeight, right: 0 }}
            />
          )}
          <UpgradeCard
            booking={booking}
            event={booking?.event}
            programVariantId={booking?.program_variant_id}
          />
          <UpgradeCard
            booking={booking}
            event={item?.event}
            programVariantId={item?.program_variant_id}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={() => handleClose()}>
          {I18n.t("App.cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpgradeDialog;
